import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Pause, Play, ArrowRight, ArrowLeftRight } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WikiFeed() {
  const [paused, setPaused] = useState(false);
  const [reverse, setReverse] = useState(false);
  const [articles, setArticles] = useState([]);
  const trackRef = useRef(null);

  useEffect(() => {
    axios.get(`${API}/wiki`).then(r => setArticles((r.data || []).slice(0, 14))).catch(() => {});
  }, []);

  const items = [...articles, ...articles];

  return (
    <section id="wiki" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-blue-500/20 bg-blue-500/10 text-blue-400 text-xs font-bold uppercase tracking-widest mb-3">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
              Bilgi Bankası
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight text-white">Wiki'den Öne Çıkanlar</h2>
            <p className="mt-4 text-base lg:text-lg text-slate-400 max-w-2xl">
              Askeri simülasyon dünyamızdaki en güncel bilgileri, sistem detaylarını ve eğitim rehberlerini buradan takip edebilirsiniz.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={() => setPaused(v => !v)} className="pill-btn text-sm bg-slate-800 hover:bg-slate-700 text-white border-slate-700">
              {paused ? <Play size={14} /> : <Pause size={14} />}
              <span>{paused ? 'Oynat' : 'Duraklat'}</span>
            </button>
            <button onClick={() => setReverse(v => !v)} className="pill-btn text-sm bg-slate-800 hover:bg-slate-700 text-white border-slate-700">
              <ArrowLeftRight size={14} />
              <span>Yönü Değiştir</span>
            </button>
            <Link to="/wiki" className="pill-btn text-sm bg-blue-600 hover:bg-blue-500 text-white border-transparent">
              <span>Tümünü Gör</span>
              <ArrowRight size={14} />
            </Link>
          </div>
        </div>

        <div className="mt-8 relative overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-20 edge-fade-left z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-20 edge-fade-right z-10" />

          {items.length > 0 && (
            <div
              ref={trackRef}
              className={`marquee-track ${paused ? 'marquee-paused' : ''}`}
              style={{ animationDirection: reverse ? 'reverse' : 'normal' }}
              onMouseEnter={() => { if (trackRef.current) trackRef.current.style.animationPlayState = 'paused'; }}
              onMouseLeave={() => { if (trackRef.current && !paused) trackRef.current.style.animationPlayState = 'running'; }}
            >
              {items.map((it, idx) => (
                <Link
                  to={`/wiki/${it.slug}`}
                  key={`${it.slug}-${idx}`}
                  className="shrink-0 w-[260px] card-soft rounded-2xl overflow-hidden block hover:-translate-y-0.5 transition-transform duration-300"
                >
                  <div className="aspect-[16/10] overflow-hidden" style={{ background: 'var(--pill-hover)' }}>
                    <img src={it.image || 'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=400'} alt={it.title} className="w-full h-full object-cover" loading="lazy" />
                  </div>
                  <div className="p-4">
                    <div className="text-sm font-semibold line-clamp-2">{it.title}</div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
